import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
@import url('https:/./fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap');

@font-face {
    font-family: "Galano Grotesque Alt";
    font-weight: normal;
    font-style: normal;
    src: url("/parcerias/fonts/galano-grotesque-alt-bold.otf") format("opentype");
    src: url("/parcerias/fonts/galano-grotesque-alt-bold.woff2") format("woff2");
    src: url("/parcerias/fonts/galano-grotesque-alt-bold.ttf") format("eot");
    src: url("/parcerias/fonts/galano-grotesque-alt-bold.eot") format("truetype");
    src: url("/parcerias/fonts/galano-grotesque-alt-bold.woff") format("woff");
}

@font-face {
    font-family: 'Open Sans';
    font-weight: normal;
    font-style: normal;
    src: url('/parcerias/fonts/OpenSans-Regular-webfont.eot') format("opentype");
    src:
        local('Open Sans'),
        local('OpenSans'),
        url('/parcerias/fonts/OpenSans-Regular-webfont.eot?#iefix') format('embedded-opentype'),
        url('/parcerias/fonts/OpenSans-Regular-webfont.woff') format('woff'),
        url('/parcerias/fonts/OpenSans-Regular-webfont.svg#open_sansregular') format('svg');
}

* {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
}

.modal-container p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;    
}

body {
    font: 400 14px 'Open Sans';
    -webkit-font-smoothing: antialiased;
}

input, button {
    font: 400 18px 'Open Sans', sans-serif;
}

button {
    cursor: pointer;
}
.ReactModal__Overlay--after-open {
    z-index: 9999;
}
`

export const borderWidth = {
    none: `0`,
    sm: `1px`,
    md: `2px`,
    lg: `4px`,
    xlg: `8px`,
}

export const borderRadius = {
    none: `0`,
    sm: `4px`,
    md: `8px`,
    lg: `15px`,
    circle: `50%`,
    pill: `9999px`,
}

/**
 * @tokens Colors
 * @presenter Color
 */
export const colorBrandPrimary = {
    turquoise: `#28c4d6`,
    marine: `#24206b`,
    darkMarine: `#100B53`,
}

export const colorBrandSecondary = {
    fuchsia: `#c11f57`,
    anil: `#561dff`,
    lime: `#d6de26`,
    amber: `#ffcc00`,
    purple: `#bd10e0`,
}

export const colorNeutralGrey = {
    10: `#f7f7fc`,
    30: `#e2e1eb`,
    40: `#d4d3dd`,
    50: `#aeabc4`,
}

export const colorNeutralDark = {
    80: `#585380`,
    90: `#110e49`,
}

export const colorNeutral = {
    light: `#ffffff`,
}
/**
 * @tokens Font Family
 * @presenter Font Family
 */
export const fontFamily = {
    brand: `Galano Grotesque Alt`,
    neutral: `Open Sans`,
}

export const fontSize = {
    xxl: `3rem`,
    xl: `2.5rem`,
    lg: `2rem`,
    md: `1.5rem`,
    xxxs: `0.75rem`,
    sm: `1.25rem`,
    xs: `1rem`,
    xxs: `0.875rem`,
}

export const shadow ={
    level1: `0 2px 6px 2px rgba(0, 0, 0, 0.12), 0 0 1px 1px rgba(0, 0, 0, 0.12)`,
    level2: `0 4px 12px 4px rgba(0, 0, 0, 0.12), 0 0 1px 1px rgba(0, 0, 0, 0.12)`,
    level3: `0 8px 24px 8px rgba(0, 0, 0, 0.12), 0 0 1px 1px rgba(0, 0, 0, 0.12)`,
}

export const marginHeight = '26px'

export default GlobalStyle
